module.exports = __webpack_public_path__ + "static/stairsPoster2-1-9016e48bc4a3a79ac4f716d85f8424d6.jpg";